import React from 'react';
import { Carousel } from 'react-bootstrap'
import { Route } from 'react-router-dom'

import '../Accueil.css'

const Articles = ( {details} ) => {
    const requireImage = chemin => {
        if("" !== chemin){
            return chemin
        }else{
            return require(`../img/default.png`)
        }
    }
    return (
        <div>
            <Carousel>
            {
                Object
                .entries(details)
                .map(key => 
                    <Carousel.Item key={key}> 
                        <img 
                        src={requireImage(key[1][1].base64)}
                        alt={key[1][1].nom}
                        />
                    <Carousel.Caption>
                        <h3>{key[1][1].nom}</h3>
                        
                    <Route render={({ history }) => (
                        <button
                        type='button'
                        className="btn btn-primary btn-blue-light"
                        onClick={() => { history.push({
                        pathname : `/articles/` + key[1][1].nom,
                        state: { recette: key[1][0] }
                        })
                        }}
                        >
                        EN LIRE PLUS
                        </button>
                    )} />

                    </Carousel.Caption>
                    </Carousel.Item>
                    )
            }
          </Carousel>
        </div>

    );
};

export default Articles;